import CheckBox from "@mui/icons-material/CheckBox";
import { DialogTitle } from "@mui/material"
import { useFormik } from "formik";
import { useState } from "react";
import { Button, Checkbox, Dialog, Grid, TextField } from "src/components"
import DialogActions from "src/components/DialogActions";
import DialogContent from "src/components/DialogContent";
import NumberField from "src/components/NumberField";
import Tab from "src/components/Tab";
import TabContext from "src/components/TabContext";
import TabList from "src/components/TabList";
import TabPanel from "src/components/TabPanel";
import BaseComponent from "src/core/base.component";
import { translate } from "src/i18n/tHelper"
import GnlKullaniciAyarDTO from "src/models/Base/Auth/GnlKullaniciAyarDTO";
import OrganizasyonMailDTO from "src/models/Mail/OrganizasyonMailDTO";
import { OrganizasyonMailApi, useLazySendMailMessageQuery, useOrganizasyonMailGetirQuery, useOrganizasyonMailGuncelleMutation } from "src/services/OrganizasyonTanim/OrganizasyonMailApi";
import { useAppDispatch, useAppSelector } from "src/store";
import MailOnTanimlar from "./MailOnTanimlar";

interface MailAyarlariProps {
    open: boolean;
    onClose: () => void;
}
const translatePath = "pages|hastaServis|order|mailAyarlari";
const MailAyarlari = (props: MailAyarlariProps): JSX.Element => {
    const organizasyon = useAppSelector(s => s.userOrganizasyon.organizasyon);
    const query = useOrganizasyonMailGetirQuery({
        organizasyonId: organizasyon.fkOrganizasyon
    }, { skip: !organizasyon.fkOrganizasyon });
    const [guncelle, guncelleState] = useOrganizasyonMailGuncelleMutation();
    const dispatch = useAppDispatch()
    const formik = useFormik({
        validateOnChange: false,
        enableReinitialize: true,
        initialValues: query.data || new OrganizasyonMailDTO(),
        onSubmit(values, formikHelpers) {
            guncelle({
                ...values,
                id: organizasyon.fkOrganizasyon
            })
                .unwrap()
                .then(res => {
                    dispatch(OrganizasyonMailApi.util.updateQueryData("organizasyonMailGetir", {
                        organizasyonId: organizasyon.fkOrganizasyon
                    },
                        draft => ({
                            ...values,
                            id: organizasyon.fkOrganizasyon
                        })
                    ))
                })
        },
    })

    const [mailGonder, mailGonderState] = useLazySendMailMessageQuery()
    const [tabValue, setTabValue] = useState("0")
    return (
        <Dialog
            open={props.open}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle>{organizasyon.organizasyon + " " + translate(translatePath, "Organizasyonuna Ait Mail Ayarları")}</DialogTitle>
            <DialogContent>
                <BaseComponent
                    loading={query.isFetching}
                >
                    <TabContext value={tabValue}
                    >
                        <TabList onChange={(e, v) => setTabValue(v)}>
                            <Tab label={translate(translatePath, "Giden Sunucu Ayarları")} value={"0"} />
                            <Tab label={translate(translatePath, "Ön Tanımlar")} value={"1"} />
                        </TabList>
                        <TabPanel value="0">
                            <Grid container>
                                <Grid item>
                                    <TextField
                                        label={translate(translatePath, "Mail Adresi")}
                                        value={formik.values.mailAddress}
                                        name="mailAddress"
                                        onChange={formik.handleChange}
                                        helperText={formik.errors.mailAddress}
                                        error={Boolean(formik.errors.mailAddress)}
                                    />
                                </Grid>
                                <Grid item>
                                    <TextField
                                        label={translate(translatePath, "Görünür Adı")}
                                        value={formik.values.mailDisplayname}
                                        name="mailDisplayname"
                                        onChange={formik.handleChange}
                                        helperText={formik.errors.mailDisplayname}
                                        error={Boolean(formik.errors.mailDisplayname)}
                                    />
                                </Grid>
                                <Grid item sm={6}>
                                    <TextField
                                        label={translate(translatePath, "Sunucu Adresi")}
                                        value={formik.values.mailHost}
                                        name="mailHost"
                                        onChange={formik.handleChange}
                                        helperText={formik.errors.mailHost}
                                        error={Boolean(formik.errors.mailHost)}
                                    />
                                </Grid>
                                <Grid item md={4} lg={3} xl={2}>
                                    <NumberField
                                        allowNegative={false}
                                        label={translate(translatePath, "Sunucu Portu")}
                                        value={formik.values.mailPort}
                                        name="mailPort"
                                        onChange={formik.handleChange}
                                        helperText={formik.errors.mailPort}
                                        error={Boolean(formik.errors.mailPort)}
                                    />
                                </Grid>
                                <Grid item md={4} lg={3} xl={2}>
                                    <Checkbox
                                        label={translate(translatePath, "SSL")}
                                        checked={formik.values.mailSsl === "E"}
                                        onChange={(e, c) => {
                                            formik.setValues({
                                                ...formik.values,
                                                mailSsl: c ? "E" : "H"
                                            })
                                        }}
                                    />
                                </Grid>
                                <Grid item md={4} lg={3} xl={2}>
                                    <Checkbox
                                        label={translate(translatePath, "İçerik Html Gönder")}
                                        checked={formik.values.mailIcerikHtml === "E"}
                                        onChange={(e, c) => {
                                            formik.setValues({
                                                ...formik.values,
                                                mailIcerikHtml: c ? "E" : "H"
                                            });
                                        }}
                                    />
                                </Grid>
                                <Grid item sm={6}>
                                    <TextField
                                        label={translate(translatePath, "Kullanıcı Adı")}
                                        value={formik.values.mailUsername}
                                        name="mailUsername"
                                        onChange={formik.handleChange}
                                        helperText={formik.errors.mailUsername}
                                        error={Boolean(formik.errors.mailUsername)}
                                    />
                                </Grid>
                                <Grid item sm={6}>
                                    <TextField
                                        label={translate(translatePath, "Şifre")}
                                        value={formik.values.mailPassword}
                                        name="mailPassword"
                                        onChange={formik.handleChange}
                                        helperText={formik.errors.mailPassword}
                                        error={Boolean(formik.errors.mailPassword)}
                                        type="password"
                                    />
                                </Grid>
                                <Grid item>
                                    <Grid container justifyContent={"right"}>
                                        <Grid item md={4}>
                                            <Button
                                                customType="mailSend"
                                                color="success"
                                                loading={mailGonderState.isLoading}
                                                onClick={(e) => {
                                                    formik.submitForm().then(e => {
                                                        mailGonder({
                                                            organizasyonId: organizasyon.fkOrganizasyon,
                                                            mailRequest: {
                                                                body: translate(translatePath, "Test Maili"),
                                                                to: [
                                                                    {
                                                                        ...new GnlKullaniciAyarDTO(),
                                                                        ayar: formik.values.mailAddress
                                                                    }
                                                                ],
                                                                subject: formik.values.mailDisplayname,
                                                            }
                                                        }).unwrap()
                                                    })
                                                }}
                                            >{translate(translatePath, "Test Maili Gönder")}</Button>
                                        </Grid>
                                        <Grid item sm={6} md={4} lg={3}>
                                            <Button
                                                customType="save"
                                                loading={guncelleState.isLoading}
                                                disabled={!formik.dirty}
                                                onClick={formik.submitForm}
                                            ></Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </TabPanel>
                        <TabPanel value="1" sx={{ p: 1 }}>
                            <MailOnTanimlar />
                        </TabPanel>
                    </TabContext>

                </BaseComponent>
            </DialogContent>
            <DialogActions>
                <Grid container justifyContent={"right"}>
                    <Grid item sm={6} md={4} lg={3}>
                        <Button
                            customType="close"
                            onClick={(e) => props.onClose()}
                        ></Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}
export default MailAyarlari;